const state = {
    isCollapse: false
};

const mutations = {
    TOGGLE_SIDEBAR: (state,isCollapse) => {
        state.isCollapse = isCollapse
    },
};

const actions = {
    toggleSideBar({ commit },data) {
        commit('TOGGLE_SIDEBAR',data)
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
